import React, { useState } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import { makeStyles } from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  Typography,
  Paper,
  Checkbox,
} from '@material-ui/core';
import CommonTableToolbar from '../../CommonComponents/TableComponents/CommonTableToolBar';
import EnhancedTableHead from '../../CommonComponents/TableComponents/EnhancedTableHead';
import {
  getComparator,
  stableSort,
} from '../../CommonComponents/TableComponents/TableUtils';
import { CommonButton, CommonModal, CommonSelect } from '../../CommonComponents';
import FallbackCard from '../../CommonComponents/FallbackCard';
import { useEffect } from 'react';
import { changeEndDate } from '../../redux/actions/sites';

const title = 'All sites list';

const headCells = [
  {
    id: 'siteId',
    numeric: false,
    disablePadding: true,
    label: 'Site Id',
  },
  {
    id: 'mediaTypeName',
    numeric: true,
    disablePadding: false,
    label: 'Media',
  },
  {
    id: 'stateName',
    numeric: true,
    disablePadding: false,
    label: 'State',
  },
  {
    id: 'cityName',
    numeric: true,
    disablePadding: false,
    label: 'City',
  },
  {
    id: 'locationName',
    disablePadding: false,
    label: 'Location',
    width: '20%',
  },
  {
    id: 'startDate',
    numeric: true,
    disablePadding: false,
    label: 'Start Date',
  },
  {
    id: 'endDate',
    numeric: true,
    disablePadding: false,
    label: 'End Date',
  },
  {
    id: 'supplierName',
    numeric: true,
    disablePadding: false,
    label: 'Supplier',
  },
  {
    id: 'frequency',
    numeric: true,
    disablePadding: false,
    label: 'Frequency',
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  title: {
    marginRight: 30,
    marginTop: 12,
    float: 'left',
  },
  assignButtonWidth: {
    marginRight: 20,
  },
  searchBar: {
    float: 'right',
    width: '100%',
  },
}));

export const EndDateFilter = ({allSites, handleChange}) => {
  const [endDatesForFilter, setEndDatesForFilter] = useState([]);
  useEffect(() => {
    setEndDatesForFilter([]);
    const allEndDates = Array.from(new Set(allSites.map(row => row.newEndDate ? row.newEndDate : row.endDate)))
    let filter = allEndDates.map(row => {
      return {
          text: row,
          value: row
      }
    })
    setEndDatesForFilter(filter);
  },[allSites])

  return (
    <CommonSelect 
      label="Select End Date for Change" 
      options={endDatesForFilter}
      handleChange={(val) => handleChange(val)} 
    />
  )
}

const ChangeDateTable = ({
  allSites,
  currentPageCount,
  selected,
  setSelected,
  setCheckbox,
  checkBoxState,
  changeEDate,
}) => {
  const classes = useStyles();
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('SiteId');
  const [page] = useState(0);
  const [newStartDate, setNewStartDate] = useState(null);
  const [showEndDateModal, setShowEndDateModal] = useState(false);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const filteredSites = selectedEndDate ? allSites.filter(row => (row.newEndDate ? row.newEndDate : row.endDate) === selectedEndDate): allSites

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (checkBoxState) {
      if (event.target.checked) {
        const newSelecteds = filteredSites.map((obj) => obj.id);
        setSelected(newSelecteds);
        setCheckbox(false);
      }
    } else {
      setCheckbox(true);
      setSelected([]);
    }
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const handleDayClick = (day) => {
    setNewStartDate(day);
  };

  const updateEndDate = async() => {
    await changeEDate({
      siteId:selected,
      newEndDate: newStartDate,
    })
    setShowEndDateModal(false);
    setSelectedEndDate(null);
    setSelected([]);
  };

  useEffect(() => {
    setSelectedEndDate(null)
  },[allSites])

  const userType = JSON.parse(localStorage.getItem('user'));
  const numSelected = selected.length;
  const canChangeEndDate =
    userType &&
    (userType.userType === 'admin' ||
      userType.userType === 'manager' ||
      userType.userType === 'supplier');
  return (
    <div className={classes.root}>
      {filteredSites.length > 0 ? (
          <div>
          <Paper className={classes.paper}>
            <CommonTableToolbar>
              <div className="row fluid">
                <div className="col-7">
                  {numSelected > 0 ? (
                    <Typography
                      className={classes.title}
                      color="primary"
                      variant="subtitle1"
                      component="div"
                    >
                      {numSelected > 1
                        ? `${numSelected} sites selected `
                        : `${numSelected} site selected `}
                    </Typography>
                  ) : (
                    <Typography
                      className={classes.title}
                      variant="h6"
                      id="tableTitle"
                      component="div"
                    >
                      {title}
                    </Typography>
                  )}
                </div>
                <div className="col-4 ml-auto">
                  <TextField
                    className={classes.searchBar}
                    id="outlined-basic"
                    label="Search this page"
                    variant="outlined"
                  />
                </div>
              </div>
            </CommonTableToolbar>
            <CommonTableToolbar>
              <div className="row fluid">
                <div className="col-4">
                  <EndDateFilter allSites={allSites} handleChange = {(val) => {
                    setSelected([]);
                    setSelectedEndDate(val);
                  }} />
                </div>
                {canChangeEndDate ?
                  <div className="col-4 ml-auto">
                      <CommonButton 
                        disabled={selected.length === 0}
                        variant="outlined"
                        color="primary"
                        size="small"
                        onClick={() => setShowEndDateModal(true)}
                      >
                        Update End Date
                      </CommonButton>
                  </div>
                :null}  
              </div>
            </CommonTableToolbar>
            <TableContainer>
              <Table
                className={classes.table}
                aria-labelledby="tableTitle"
                size="medium"
                aria-label="enhanced table"
              >
                <EnhancedTableHead
                  headCells={headCells}
                  classes={classes}
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={
                    canChangeEndDate && selectedEndDate ? handleSelectAllClick : null
                  }
                  onRequestSort={handleRequestSort}
                  rowCount={filteredSites.length}
                  checkbox
                />
                <TableBody>
                  {stableSort(filteredSites, getComparator(order, orderBy))
                    .slice(
                      page * currentPageCount,
                      page * currentPageCount + currentPageCount
                    )
                    .map((row, index) => {
                      const isItemSelected = isSelected(row.id);
                      const labelId = `enhanced-table-checkbox-${index}`;
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={row.id}
                          selected={isItemSelected}
                        >
                          <TableCell padding="checkbox">
                            {selectedEndDate ? (
                              <Checkbox
                                color="primary"
                                checked={isItemSelected}
                                inputProps={{ 'aria-labelledby': labelId }}
                                onChange={(event) => handleClick(event, row.id)}
                              />
                            ) : null}
                          </TableCell>
                          <TableCell
                            component="th"
                            id={labelId}
                            scope="row"
                            padding="none"
                          >
                            {row.siteId}
                          </TableCell>
                          <TableCell>{row.mediaTypeName}</TableCell>
                          <TableCell>{row.stateName}</TableCell>
                          <TableCell>{row.cityName}</TableCell>
                          <TableCell>{row.locationName}</TableCell>
                          <TableCell align="center" padding="none">
                            {moment(
                              row.newStartDate
                                ? row.newStartDate
                                : row.startDate
                            ).format('DD MMM YYYY')}
                          </TableCell>
                          <TableCell align="center" padding="none">
                            {moment(row.newEndDate ? row.newEndDate : row.endDate).format('DD MMM YYYY')}
                          </TableCell>
                          <TableCell>{row.supplierName}</TableCell>
                          <TableCell>{row.frequency}</TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
          {showEndDateModal && (
            <CommonModal
              title="Change End Date"
              open
              width="md"
              onYes={updateEndDate}
              onClose={() => {
                setNewStartDate(null);
                setShowEndDateModal(false);
              }}
              saveBtnDisable={!newStartDate}
              successButtonText="Change"
              cancelButtonText="Cancel"
            >
              <DayPicker
                disabledDays={[
                  new Date(
                    moment(selectedEndDate).format('YYYY'),
                    moment(selectedEndDate).format('MM') - 1,
                    moment(selectedEndDate).format('DD')
                  ),
                  {
                    before: new Date(moment(selectedEndDate).format('YYYY'), moment(selectedEndDate).format('MM') - 1, moment(selectedEndDate).format('DD')),
                  }
                ]}
                selectedDays={newStartDate}
                onDayClick={handleDayClick}
              />
            </CommonModal>
          )}
        </div>
      ) : (
        <FallbackCard text="No data found" />
      )}
    </div>
  );
};

const mapState = (state) => ({
  allSites: state.sites.allSites,
  currentPageCount: state.sites.currentPageCount,
});

const mapActions = {
  changeEDate: changeEndDate,
};

export default connect(mapState, mapActions)(ChangeDateTable);
